export function getGeoLocation() {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
}

export function filterAndSort(context, state, isPresetStore) {
  let shopList = [];

  if (context.countryFilter !== "0" || context.addressFilter !== "") {
    shopList = state.shops.filter(
      (shop) => {

        if (isPresetStore && shop.storeId === state.shopSelectedId) {
          return false;
        }

        if (context.countryFilter === "0" && context.addressFilter === "") {
          return true;
        }

        const country = context.countryFilter === "0" || (context.countryFilter != "0" && shop.country === context.countryFilter);

        const address = context.addressFilter === "" || (context.addressFilter !== "" && (shop.name.toLowerCase().includes(context.addressFilter.toLowerCase()) ||
          shop.line1.toLowerCase().includes(context.addressFilter.toLowerCase()) ||
          shop.line2.toLowerCase().includes(context.addressFilter.toLowerCase()) ||
          shop.zipCode.toLowerCase().includes(context.addressFilter.toLowerCase())));

        return country && address;
      }
    );
  } else {
    shopList = state.shops.filter((shop) => {
      if (isPresetStore && shop.storeId === state.shopSelectedId) {
        return false;
      }
      return true;
    });
  }

  shopList.sort((a, b) => {
    const distanceA = getDistanceInKmBetweenEarthCoordinates(
      state.userGeoLocation.latitude,
      state.userGeoLocation.longitude,
      a.latitude,
      a.longitude
    );
    const distanceB = getDistanceInKmBetweenEarthCoordinates(
      state.userGeoLocation.latitude,
      state.userGeoLocation.longitude,
      b.latitude,
      b.longitude
    );
    return distanceA - distanceB;
  });

  if (isPresetStore) {
    shopList.unshift(state.shopSelected);
  }
  return shopList;
}

export function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function getDistanceInKmBetweenEarthCoordinates(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

/**
 * Fetch store image data from REST API
 * @param {number} storeId - The store post ID
 * @param {string} size - Optional image size (default: 'full')
 * @returns {Promise<Object>} Image data including src, srcset, sizes, and alt
 */
export async function getStoreDetails(storeId, size = "full") {
  try {
    const response = await fetch(
      `/wp-json/cc-lvlgroup-marketing/v1/store-api/store-details/${storeId}?size=${size}`
    );

    if (!response.ok) {
      return {
        content: "",
        src: "https://resize.sprintercdn.com/f/768x768/products/0376273/skechers-summits-torre_0376273_00_4_3874119000.jpg?w=768&q=75",
        srcset: "",
        sizes: "",
        alt: "",
      };
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching store details:", error);
    return null;
  }
}

// Example usage in your components:
export async function getStoreImageData(storeId, size = "full") {
  try {
    const response = await fetch(
      `/wp-json/cc-lvlgroup-marketing/v1/store-api/store-image/${storeId}?size=${size}`
    );
    if (!response.ok) {
      return null;
    }
    const imageData = await response.json();
    if (imageData) {
      return imageData;
    }
  } catch (error) {
    console.error("Error fetching store details:", error);
  }

  return null;
}

export async function getStoreImage(storeId, size = "full") {
  const imageData = await getStoreImageData(storeId, size);

  if (imageData) {
    const img = document.createElement("img");
    img.src = imageData.src;
    img.srcset = imageData.srcset;
    img.sizes = imageData.sizes;
    img.alt = imageData.alt;
    return img;
  }

  return imageData;
}

export function loadThumbnails(state) {
  if (state.thumbnailsLoaded) {
    return;
  }

  state.shops = state.shops.map((store) => {
    if (store.thumbnail === "") {
      store.thumbnail = {
        src: "/wp-content/themes/enfold-child/assets/img/skechers_logo-1030x185.png",
        srcset: "",
        sizes: "",
        alt: "SKECHERS by LVL Group",
      };
      return store;
    }
    const fileName = store.thumbnail;
    const fileNameNoExt = fileName.slice(0, fileName.lastIndexOf("."));
    const ext = fileName.substring(fileNameNoExt.length + 1);
    const srcset = `${fileNameNoExt}-450x338.${ext} 450w, ${fileNameNoExt}-705x529.${ext} 705w, ${fileNameNoExt}-1030x773.${ext} 1030w`;
    const sizes =
      "(max-width: 450px) 90vw, (max-width: 782px) 90vw, (max-width: 1030px) 33vw, 25vw";
    store.thumbnail = {
      src: "/wp-content/themes/enfold-child/assets/img/skechers_logo-1030x185.png",
      srcset: srcset,
      sizes: sizes,
      alt: fileNameNoExt,
    };
    return store;
  });
  state.thumbnailsLoaded = true;
  state.shopView = state.shops;
}
